(function () {
  'use strict';

  var SELECTOR_ROOT = '[data-region-selector]';
  var mobileRegionQuery = window.matchMedia('(max-width: 768px)');
  var redirectMapCache = {};
  var localePathPattern = /^\/(de|fr|es-es|it|pl|el|nl)(\/|$)/;

  function normalizeSearchText(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/\p{M}+/gu, '')
      .toLocaleLowerCase(document.documentElement.lang || undefined)
      .replace(/[^\p{L}\p{N}\s/.-]+/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      url.protocol = 'https:';
      url.hash = '';
      url.search = '';
      if (url.pathname !== '/' && url.pathname.slice(-1) === '/') {
        url.pathname = url.pathname.slice(0, -1);
      }
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function currentUrlCandidates() {
    var current = new URL(window.location.href);
    var candidates = [normalizeUrl(current.href)];
    var localizedPath = current.pathname.match(localePathPattern);

    if (localizedPath) {
      current.pathname = current.pathname.replace(localePathPattern, '/');
      candidates.push(normalizeUrl(current.href));
    }

    return candidates.filter(Boolean);
  }

  function getRegionPath(value) {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return '/';
    }
  }

  function updateCurrentRegionText(regionRoot) {
    var currentText = regionRoot.querySelector('.ar-current-country-text');
    if (!currentText) return;

    var currentHost = window.location.hostname.replace(/^www\./, '');
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    var bestMatch = null;
    var bestScore = -1;

    Array.prototype.forEach.call(regionRoot.querySelectorAll('[data-region-label][data-region-url]'), function (item) {
      try {
        var itemUrl = new URL(item.dataset.regionUrl, window.location.origin);
        var itemHost = itemUrl.hostname.replace(/^www\./, '');
        var itemPath = getRegionPath(itemUrl.href);
        var hostMatches = itemHost === currentHost;
        var pathMatches = itemPath === currentPath;
        var rootPathMatches = itemPath === '/' && currentPath === '/';
        var nestedPathMatches = itemPath !== '/' && currentPath.indexOf(itemPath + '/') === 0;

        if (!hostMatches && !pathMatches && !nestedPathMatches) return;

        var score = hostMatches ? 100 : 0;
        if (pathMatches) score += 20;
        if (rootPathMatches) score += 5;
        if (nestedPathMatches) score += itemPath.length;
        if (!hostMatches && rootPathMatches) score -= 50;

        if (score > bestScore) {
          bestMatch = item;
          bestScore = score;
        }
      } catch (error) {
        return;
      }
    });

    if (bestMatch && bestMatch.dataset.regionLabel) {
      currentText.textContent = bestMatch.dataset.regionLabel;
      Array.prototype.forEach.call(document.querySelectorAll('.ar-footer-trigger__label, .ar-drawer-trigger__label'), function (el) {
        el.textContent = bestMatch.dataset.regionLabel;
      });
    }
  }

  function loadRedirectMap(mapUrl) {
    if (!mapUrl) return Promise.resolve(null);
    if (!redirectMapCache[mapUrl]) {
      redirectMapCache[mapUrl] = window.fetch(mapUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load region redirect map');
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    return redirectMapCache[mapUrl];
  }

  function findRedirectUrl(map, targetSite, fallbackUrl) {
    if (!map || !targetSite) return fallbackUrl;

    var candidates = currentUrlCandidates();
    var routes = Array.isArray(map.routes) ? map.routes : [];
    var matchedRoute = routes.find(function (route) {
      return route.urls && Object.keys(route.urls).some(function (siteKey) {
        return candidates.indexOf(normalizeUrl(route.urls[siteKey])) !== -1;
      });
    });

    return matchedRoute && matchedRoute.urls && matchedRoute.urls[targetSite]
      ? matchedRoute.urls[targetSite]
      : (map.fallback_url_by_site && map.fallback_url_by_site[targetSite]) || fallbackUrl;
  }

  function initRegionSelector(regionRoot) {
    if (!regionRoot) return;
    if (regionRoot.dataset.regionSelectorReady === 'true') {
      updateCurrentRegionText(regionRoot);
      return;
    }
    regionRoot.dataset.regionSelectorReady = 'true';

    var dialog = regionRoot.querySelector('.ar-select-country-dialog');
    var localizationForm = regionRoot.querySelector('form[action*="/localization"]');
    var countryInput = localizationForm ? localizationForm.querySelector('input[name="country_code"]') : null;
    var localeInput = localizationForm ? localizationForm.querySelector('input[name="locale_code"]') : null;
    var returnToInput = localizationForm ? localizationForm.querySelector('input[name="return_to"]') : null;
    var searchInput = regionRoot.querySelector('.ar-region-search__input');
    var searchFrame = null;
    var redirectMapUrl = regionRoot.dataset.redirectMapUrl;

    updateCurrentRegionText(regionRoot);

    var regionGroups = Array.prototype.map.call(regionRoot.querySelectorAll('.ar-region-group'), function (group) {
      var items = Array.prototype.map.call(group.querySelectorAll('.ar-region-item'), function (item) {
        var name = item.querySelector('.ar-region-item__name');
        var meta = item.querySelector('.ar-region-item__meta');

        return {
          element: item,
          searchText: normalizeSearchText([
            name ? name.textContent : '',
            meta ? meta.textContent : ''
          ].join(' '))
        };
      });

      return {
        element: group,
        items: items
      };
    });

    function filterRegions(rawQuery) {
      var terms = normalizeSearchText(rawQuery).split(' ').filter(Boolean);

      regionGroups.forEach(function (groupData) {
        var visibleCount = 0;

        groupData.items.forEach(function (itemData) {
          var isVisible = terms.length === 0 || terms.every(function (term) {
            return itemData.searchText.indexOf(term) !== -1;
          });

          itemData.element.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        groupData.element.hidden = visibleCount === 0;
      });
    }

    if (dialog && searchInput) {
      dialog.addEventListener('modal:handleAfterShow', function () {
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        if (searchFrame) window.cancelAnimationFrame(searchFrame);

        searchFrame = window.requestAnimationFrame(function () {
          filterRegions(searchInput.value);
          searchFrame = null;
        });
      });

      searchInput.addEventListener('search', function () {
        filterRegions(searchInput.value);
      });
    }

    // Group toggle clicks: dialog may be portaled to <body>, so listen on document.
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.ar-region-group__toggle');
      if (!toggle || !mobileRegionQuery.matches) return;

      var group = toggle.closest('.ar-region-group');
      if (!group) return;

      var isCollapsed = group.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', String(!isCollapsed));
    });

    // Redirect link clicks: dialog may be portaled to <body>, so listen on document
    // and skip the regionRoot.contains() check (it would always fail for portaled links).
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.js-ar-region-redirect');
      if (!link || !link.dataset.targetSite) return;

      event.preventDefault();

      var fallbackUrl = link.dataset.defaultUrl || link.getAttribute('href') || '/';
      var euLocale = link.dataset.euLocale;
      loadRedirectMap(redirectMapUrl).then(function (map) {
        var targetUrl = findRedirectUrl(map, link.dataset.targetSite, fallbackUrl);

        // EU multi-language: when target is global.arzopa.com and a locale prefix
        // is configured (de/fr/es/it/pl/el/nl), prepend it to the pathname.
        if (euLocale && euLocale !== 'global-en') {
          try {
            var u = new URL(targetUrl);
            if (u.hostname === 'global.arzopa.com') {
              var path = u.pathname;
              if (path.charAt(0) !== '/') path = '/' + path;
              // strip any existing locale prefix to avoid doubling
              path = path.replace(/^\/(de|fr|es-es|it|pl|el|nl)(\/|$)/, '/');
              u.pathname = '/' + euLocale + path;
              targetUrl = u.toString();
            }
          } catch (e) {}
        }

        window.location.href = targetUrl;
      });
    });

    (dialog || regionRoot).addEventListener('click', function (event) {
      var button = event.target.closest('.js-ar-region-localization-submit');
      if (!button) return;

      if (!localizationForm) {
        window.location.href = button.dataset.returnTo || '/';
        return;
      }

      if (countryInput) {
        if (button.dataset.countryCode) {
          countryInput.value = button.dataset.countryCode;
          countryInput.disabled = false;
        } else {
          countryInput.value = '';
          countryInput.disabled = true;
        }
      }

      if (localeInput) localeInput.value = button.dataset.languageCode || '';
      if (returnToInput) returnToInput.value = button.dataset.returnTo || window.location.pathname;

      if (!button.dataset.countryCode && !button.dataset.languageCode) {
        window.location.href = button.dataset.returnTo || '/';
        return;
      }

      localizationForm.submit();
    });

  }

  // Region trigger proxies (footer / drawer): lightweight buttons that
  // delegate to the main trigger (#ar-current-country) so we only
  // initialize one dialog instance.
  document.addEventListener('click', function (event) {
    var proxy = event.target.closest('[data-footer-region-trigger], [data-drawer-region-trigger]');
    if (!proxy) return;
    event.preventDefault();
    var mainTrigger = document.querySelector(SELECTOR_ROOT + ' #ar-current-country');
    if (mainTrigger) mainTrigger.click();
  });

  function initRegionSelectors(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SELECTOR_ROOT), initRegionSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRegionSelectors(document);
    });
  } else {
    initRegionSelectors(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRegionSelectors(event.target);
  });

  window.addEventListener('load', function () {
    initRegionSelectors(document);
  });
})();
